export const ShortNumber = ({ value }: { value: number | null | undefined }) => {
  // 1. Handle invalid inputs or 0 specifically
  if (value === null || value === undefined || isNaN(value)) return null;
  if (value === 0) return <span>0</span>;

  // 2. Determine formatting
  const formatNumber = (num: number) => {
    // Step A: Apply the "2 significant figures" rule to the raw number first.
    // This handles edge cases like 999 -> 1000 (which should become 1k, not 1000)
    const rounded = Number(num.toPrecision(2));

    // Step B: Determine the suffix based on the rounded number
    // We use the rounded number for the tier check to ensure 999 -> 1k
    const tiers = [
      { value: 1e9, symbol: "G" },
      { value: 1e6, symbol: "M" },
      { value: 1e3, symbol: "k" },
      { value: 1, symbol: "" },
    ];

    // Find the largest tier that is smaller than or equal to the number
    const tier = tiers.find((t) => Math.abs(rounded) >= t.value);

    // Provide a fallback for very small numbers if necessary
    if (!tier) return String(rounded);

    // Step C: Divide and format
    // Remove trailing zeros/decimals automatically using Number()
    const scaled = rounded / tier.value;

    return `${scaled}${tier.symbol}`;
  };

  return <span title={value.toLocaleString()}>{formatNumber(value)}</span>;
};
